import { useMemo } from 'react';

import { useAppSelector } from '@/hooks/redux-hooks';

import groupMarketsBySector from '../utils/groupMarketsBySector';

export const useMarketsNavigationItems = () => {
  const { groupedMarkets, status } = useAppSelector(state => state.marketsList);
  const menuItems = useMemo(() => {
    return groupMarketsBySector(groupedMarkets);
  }, [groupedMarkets]);

  return {
    menuItems,
    status
  };
};
